import { Button } from '@/common/ui/button'
import { useGameTypeSelector } from '@/common/hooks/useGameTypeSelector'
import { useState, useEffect } from 'react'

type GameType =
	| ''
	| 'SLOT'
	| 'CASINO'
	| 'SPORT'
	| 'LOTTO'
	| 'FISHING'
	| 'POPULAR'

interface GameTypeSelectorProps {
	excludeOptions?: GameType[]
}

export default function GameTypeSelector({
	excludeOptions = [],
}: GameTypeSelectorProps) {
	const { gameType, setGameType, popular, setPopular } = useGameTypeSelector()
	const [activeButton, setActiveButton] = useState<GameType>(
		gameType.gameType as GameType,
	)

	// Sync local state with global state when global state changes
	useEffect(() => {
		if (popular) {
			setActiveButton('POPULAR')
		} else {
			setActiveButton(gameType.gameType as GameType)
		}
	}, [gameType.gameType, popular])

	const handleGameTypeChange = (type: GameType) => {
		setActiveButton(type)
		setPopular(false)
		setGameType({ gameType: type })
	}

	const handlePopularClick = () => {
		const newPopularState = !popular

		if (newPopularState) {
			setActiveButton('POPULAR')
		} else {
			setActiveButton('')
		}

		setPopular(newPopularState)
		setGameType({ gameType: '' })
	}

	const isExcluded = (option: GameType) => excludeOptions.includes(option)

	return (
		<div className="flex flex-wrap items-center gap-2">
			{!isExcluded('') && (
				<Button
					variant={activeButton === '' ? 'default' : 'secondary'}
					isActive={activeButton === ''}
					onClick={() => handleGameTypeChange('')}
				>
					ทั้งหมด
				</Button>
			)}
			{!isExcluded('SLOT') && (
				<Button
					variant={activeButton === 'SLOT' ? 'default' : 'secondary'}
					isActive={activeButton === 'SLOT'}
					onClick={() => handleGameTypeChange('SLOT')}
				>
					สล็อต
				</Button>
			)}
			{!isExcluded('CASINO') && (
				<Button
					variant={activeButton === 'CASINO' ? 'default' : 'secondary'}
					isActive={activeButton === 'CASINO'}
					onClick={() => handleGameTypeChange('CASINO')}
				>
					คาสิโน
				</Button>
			)}
			{!isExcluded('SPORT') && (
				<Button
					variant={activeButton === 'SPORT' ? 'default' : 'secondary'}
					isActive={activeButton === 'SPORT'}
					onClick={() => handleGameTypeChange('SPORT')}
				>
					กีฬา
				</Button>
			)}
			{!isExcluded('LOTTO') && (
				<Button
					variant={activeButton === 'LOTTO' ? 'default' : 'secondary'}
					isActive={activeButton === 'LOTTO'}
					onClick={() => handleGameTypeChange('LOTTO')}
				>
					หวย
				</Button>
			)}
			{!isExcluded('FISHING') && (
				<Button
					variant={activeButton === 'FISHING' ? 'default' : 'secondary'}
					isActive={activeButton === 'FISHING'}
					onClick={() => handleGameTypeChange('FISHING')}
				>
					ตกปลา
				</Button>
			)}
			{!isExcluded('POPULAR') && (
				<Button
					variant={activeButton === 'POPULAR' ? 'default' : 'secondary'}
					isActive={activeButton === 'POPULAR'}
					onClick={handlePopularClick}
				>
					ยอดนิยม
				</Button>
			)}
		</div>
	)
}
